

/// <reference path="CoreItem.ts" />

// Generated class ConceptItem_ManagedObject

class ConceptItem_ManagedObject extends CoreItem
{
}
